import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from './constants';

const textCardContentConverter = {
  toFirestore(
    content: Studio.TextCardContent,
  ): firebase.firestore.DocumentData {
    return { ...content };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): Studio.TextCardContent {
    const data = snapshot.data(options);
    return data as Studio.TextCardContent;
  },
};

// The bodies of dashboard and report Text cards, keyed by the card's
// textContentId
const getTextCardContentsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.TEXT_CARD_CONTENTS_COLLECTION)
    .withConverter(textCardContentConverter);
};

export default getTextCardContentsRef;
